// @flow
import { type ReservationType } from 'types/v1/reservation'

export function getReservationGetPointBlockProps(
  reservation: ReservationType,
  unapprovedReservation: ReservationType,
) {
  return {
    nextPoint: unapprovedReservation.point_amount_text,
    prevPoint:
      unapprovedReservation.point_amount_text !==
        reservation.point_amount_text && reservation.point_amount_text,
  }
}

export function getReservationGetPointBlockPropsOnlyNext(
  reservation: ReservationType,
) {
  if (!reservation.point_amount_text) {
    return null
  }

  return {
    nextPoint: reservation.point_amount_text,
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationGetPointBlock/presenter.jsx